import $ from 'jquery';

export default class abgrcs_config {
	site_url;
	static user_inf;

	constructor() {
		this.site_url = "http://localhost/projects/app-int-journals/app-int";
	}

	static getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}
	
	static create_cookie(name, value, days)
	{
	  if (days)
	  {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	  }
	  else
		var expires = "";
	  
	  document.cookie = name + " = " + value + "; expires = " + expires + ";";
	}

	static eraseCookie(name) {   
		document.cookie = name+'=; Max-Age=-99999999; path=/';  
	}

	static save_static(abgrcs_type)
	{
		$.post(abgrcs_config.site_url + "/index.php?function=set_static&abgrcs_type=" + abgrcs_type, function(abgrcs_data){
			
		});
	}
}

if( true )
{
	abgrcs_config.site_url = "https://green-journals.com/ab/green-journals-api";
}